module.exports = __webpack_public_path__ + "static/media/Prof_ten_talk.93dd7b04.gif";